import { Box, type BoxProps, CircularProgress, Typography } from "@mui/material";

type LoadingIndicatorProps = BoxProps & {
  message?: string;
  loaderSize?: number;
  hideLoader?: boolean;
  hideMessage?: boolean;
};

export default function LoadingIndicator({
  message = "Loading more",
  loaderSize = 24,
  hideLoader,
  hideMessage,
  children,
  sx,
  ...restProps
}: LoadingIndicatorProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        gap: 12,
        height: loaderSize + 12,
        ...sx
      }}
      {...restProps}
    >
      {!hideLoader && <CircularProgress size={loaderSize} />}
      {!hideMessage && (
        <Typography color='grey.300' className='loader-message'>
          {message}
        </Typography>
      )}
      {children}
    </Box>
  );
}
